import React, { useEffect, useState } from 'react';
import Header from 'pages/Header/HeaderNavegacion';
import BarraCP from 'components/BarCP/BarHeaderCP';
import { decodeStorage } from 'functions/storageBase64';
import Footer from 'pages/Footer/FooterDesktop';
import { MenuPoliticas } from 'components/MenuAutocenter/menuAutocenter';
import "./style.sass";
import { useHistory } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile';

const title = "AVISO DE PRIVACIDAD PROSPECTOS SEARS";

const TextDataPrivacidad = () => {

    return (
        <div className="contentTextData">
            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Quién dará tratamiento a sus datos personales?</h2>
                    <p>GS Tiendas Departamentales, S. A. de C. V., (en adelante Sears) con domicilio en Lago Zúrich No. 245, Edificio Presa Falcón piso 7, colonia Ampliación Granada, alcaldía Miguel Hidalgo, C.P. 11529, Ciudad de México, será el responsable del tratamiento de sus datos personales.</p>
                    <p>Para cualquier duda relacionada con la protección de sus datos personales podrá contactar a nuestro Departamento de Protección de Datos de Sears a la dirección electrónica <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué información vamos a recabar?</h2>
                    <p>Sears para cumplir con las finalidades señaladas en el presente Aviso recabará y tratará datos personales de identificación, incluyendo su imagen personal que podrá ser registrada a través de vídeos y/o fotografías cuando ingresa a nuestras sucursales, datos personales de contacto, datos fiscales, datos patrimoniales y/o financieros. Le informamos que para efectos de lo señalado en el presente aviso de privacidad Sears no tratará datos personales sensibles.</p>
                    <p>Asimismo, le informamos que para efectos de lo señalado en el presente Aviso de Privacidad Sears dará tratamiento a datos personales de terceros en calidad de referencias personales, por lo que al proporcionar los datos personales de dichos terceros para que Sears les contacte por medios físicos y/o electrónicos usted reconoce haber recabado el consentimiento requerido en términos de la normatividad aplicable.</p>
                    <p>En caso de que usted nos contacte por redes sociales, podremos recabar los datos de su perfil público de redes sociales para darle atención a sus peticiones y/o solicitudes de información en relación con los productos que ofrecemos, podremos dar tratamiento a la información contenida en su perfil público de la red social de que se trate, así como al contenido de sus publicaciones.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>No tratamiento de datos personales de menores de edad</h2>
                    <p>Sears no recaba datos personales o información directamente de menores de edad. En el supuesto de que se proporcionen datos relacionados con personas menores de edad asumiremos que la persona que los proporciona es el padre, madre y/o tutor legal, quien reconoce haber leído y aceptado el presente aviso de privacidad.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Tratamiento automatizado de datos sin decisión humana valorativa y actividades de perfilamiento</h2>
                    <p>Le informamos que para dar cumplimiento a las finalidades previstas en este Aviso de Privacidad Sears realizará tratamientos automatizado de datos personales como parte de un proceso de toma de decisiones sin intervención humana valorativa y técnicas de análisis masivo de datos para realizar actividades de perfilamiento a partir de sus hábitos de consumo, gustos e intereses, monitorear su comportamiento y ofrecerle una experiencia personalizada en relación con el uso de los servicios, así como para dar cumplimiento a algunas(s) de las finalidades(es) informadas en el presente Aviso de Privacidad.</p>
                    <p>Si usted no desea que sus datos personales sean utilizados mediante mecanismos o tecnologías automatizadas, puede oponerse a ese tratamiento en cualquier momento siguiendo el procedimiento para el ejercicio de sus derechos ARCO.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Para qué fines usamos su información?</h2>
                    <p>Sears tratará sus datos personales para las siguientes finalidades primarias y necesarias:</p>
                    <ul className="ulQuestionDisc">
                        <li>Analizar si usted cumple con los requisitos necesarios para el otorgamiento del crédito solicitado;</li>
                        <li>Realizar consultas, investigaciones y revisiones en relación con su comportamiento crediticio en Sociedades de Información Crediticia;</li>
                        <li>Verificar y confirmar su identidad; incluyendo realizar procesos de verificación de datos mediante el uso de datos biométricos;</li>
                        <li>Acreditar, validar y verificar su identidad ante los registros del Instituto Nacional Electoral;</li>
                        <li>Solicitar referencias personales sobre usted;</li>
                        <li>Informarle sobre el estatus de su solicitud;</li>
                        <li>Otorgamiento de créditos;</li>
                        <li>Realizar actividades de análisis de su comportamiento crediticio y emisión de calificaciones crediticias;</li>
                        <li>Análisis de datos mediante el uso de tecnologías de analítica y/o inteligencia artificial;</li>
                        <li>Cancelación de datos después de tres años en caso de no cumplir con los requisitos para el crédito;</li>
                        <li>Alimentar la base de datos del buró de crédito;</li>
                        <li>Atender sus solicitudes de información, dudas y/o reclamaciones;</li>
                        <li>Contactar a través de llamadas telefónicas, correos electrónicos, mensajes cortos y servicios de mensajería instantánea;</li>
                        <li>Identificarlo como visitante en nuestras sucursales y tratamiento de su imagen;</li>
                        <li>Ejercicio o defensa de un derecho en procesos administrativos y/o judiciales;</li>
                        <li>Dar cumplimiento a las políticas y procedimientos de carácter interno;</li>
                        <li>Dar cumplimiento a obligaciones previstas en la normatividad aplicable.</li>
                    </ul>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué otros usos podemos darle a su información?</h2>
                    <p>De manera adicional, si usted no se opone, Sears podrá mantener su información personal para las siguientes finalidades secundarias:</p>
                    <ul className="ulQuestionDisc">
                        <li>Informarle del lanzamiento de nuevos productos, servicios, promociones y ofertas;</li>
                        <li>Posibles contactos posteriores para ofrecimiento de productos;</li>
                        <li>Compartir perfiles y hábitos de consumo con socios comerciales y Empresas del Grupo;</li>
                        <li>Enviar publicidad y comunicaciones con fines de mercadotecnia y tele-marketing.</li>
                    </ul>
                    <p>En caso de que no desee que sus datos sean tratados para estas finalidades, puede comunicarlo al correo <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿A qué terceros podemos transferir su información?</h2>
                    <p>Sears podrá transferir sin requerir de su consentimiento los datos necesarios a autoridades administrativas y judiciales, así como a empresas Subsidiarias, afiliadas o bajo control Común para dar cumplimiento a las finalidades señaladas.</p>
                    <p>Podrá entregar información a autoridades fiscales en cumplimiento con la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita.</p>
                    <p>Transferirá datos a socios comerciales y terceros para servicios de entrega, postventa, gestión de cuentas y comunicaciones de marketing.</p>
                    <p>Si usted no se opone, Sears podrá transferir datos a socios comerciales para ofrecimiento de bienes y servicios. Puede oponerse enviando un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede ejercer sus derechos ARCO y/o revocar su consentimiento?</h2>
                    <p>Usted o su representante legal podrá ejercer los derechos de acceso, rectificación, cancelación u oposición enviando un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a>.</p>
                    <p>Debe solicitar el Formato de Solicitud de Derechos ARCO a dicha dirección y acompañarlo con copia de una identificación oficial vigente.</p>
                    <p>El plazo de respuesta es de veinte (20) días hábiles, haciéndose efectiva en los quince (15) días siguientes si resulta procedente.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede limitar el uso y/o divulgación de sus datos?</h2>
                    <p>Podrá limitar el uso o divulgación enviando su solicitud a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> para ser registrado en el listado de exclusión propio de Sears.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo le notificaremos de los cambios que efectuemos al presente Aviso de Privacidad?</h2>
                    <p>Sears le notificará de cualquier cambio a través de su página de internet <a href="http://www.sears.com.mx" target="_blank" rel="noopener noreferrer">http://www.sears.com.mx</a>.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo protegemos sus transacciones?</h2>
                    <p>Implementamos un servidor seguro bajo el protocolo SSL (Secure Socket Layer) para que la información se transmita encriptada. Verifique que aparezca una "S" en la barra de navegación "httpS"://.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Autoridad de Protección de Datos Personales (UPDP-SABG)</h2>
                    <p>Tiene el derecho de acudir ante la Unidad de Protección de Datos Personales de la Secretaría Anticorrupción y Buen Gobierno (SABG) para hacer efectivos sus derechos.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Aceptación de Aviso de Privacidad</h2>
                    <p>Al hacer uso de nuestros servicios y proporcionar sus datos, significa que usted ha leído, entendido, y acordado los términos expuestos en el presente Aviso de Privacidad.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <p><span className='bold'>Fecha de última actualización:</span> enero 2026</p>
                </div>
            </div>
        </div>
    )
}

export function AvisoProspectosDesktop() {
    const codigoP = decodeStorage('codigoPostal');
    const [codigoPostal, setCodigoPsotal] = useState(codigoP);

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Avido de Privacidad Prospectos Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        //setLoading(false)
    }, [codigoPostal])

    //recibe la direccion del CP
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
            //console.log('')
        }
    }, [upCP, updateCPBar])

    return (
        <>
            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
            <section className="barCpResponsive">
                <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
            </section>

            <main>
                <section className="sectionAuto">
                    <div className="sectionMenu">
                        <MenuPoliticas />
                    </div>

                    <div className="sectionContent">
                        <section className="sectionTitleAuto">
                            <div className="divTitle">
                                <p>{title}</p>
                            </div>
                        </section>
                        <TextDataPrivacidad />
                    </div>
                </section>
            </main>

            <Footer />

        </>
    )
}

export function AvisoProspectosMobile() {

    const history = useHistory();
    const isNativeApp = window.location.search.indexOf('isNativeApp=true')
    // cerrar modal
    const onClose = () => {
        // history.goBack(-1);
        window.location.href = "/acerca-sears"
    }

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Aviso de Privacidad Prospectos Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <div className="modalDetallePedido full">
                <div className="contentModal">
                    {isNativeApp < 0
                        ?
                            
                            <div className="contentCloseAN">
                                <div className="btn closeBack" onClick={onClose} ></div>
                                <p className="title">{title}</p>
                            </div>
                        :null
                    }

                    <TextDataPrivacidad />

                </div>
            </div>

        </>
    )
}

export function AvisoProspectos() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Aviso de Privacidad Prospectos Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            { isMobile &&
                isMobile === 'desktop'
                ? <AvisoProspectosDesktop />

                : isMobile === 'movile'
                    ? null
                    : <AvisoProspectosMobile />
            }
        </>
    )
}